import { useEffect, useState } from 'react';
import ModalFavoriteMealNutrition from '../../modal/views/ModalFavoriteMealNutrition';

const FavoriteModal = ({ mealId, title }) => {
    const [isOpen, setIsOpen] = useState(false);

    // OPEN VIA ICON BUTTON (FROM BLADE)
    useEffect(() => {
        const handler = (e) => {
            const trigger = e.target.closest(`[data-open-favorite-modal="${mealId}"]`);
            if (trigger) setIsOpen(true);
        };

        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, [mealId]);

    // BODY SCROLL LOCK
    useEffect(() => {
        document.body.classList.toggle('modal-open', isOpen);
        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    return (
        <>
            {title && (
                <span className="meal-title" onClick={() => setIsOpen(true)}>
                    {title}
                </span>
            )}

            {isOpen && (
                <div className="modal" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <ModalFavoriteMealNutrition
                                favoriteId={mealId}
                                title={title}
                                onRequestClose={() => setIsOpen(false)}
                            />
                        </div>
                    </div>

                    <div className="modal-backdrop fade in" onClick={() => setIsOpen(false)} />
                </div>
            )}
        </>
    );
};

export default FavoriteModal;
